var _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRecordWaveRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 11,
    y2: -1,
    transform: "matrix(4.37112e-08 1 1 -4.37112e-08 26.5 6)",
    stroke: "#867BEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 23,
    y2: -1,
    transform: "matrix(4.37112e-08 1 1 -4.37112e-08 18.5 0)",
    stroke: "#867BEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 11,
    y2: -1,
    transform: "matrix(4.37112e-08 1 1 -4.37112e-08 10.5 6)",
    stroke: "#867BEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 23,
    y2: -1,
    transform: "matrix(4.37112e-08 1 1 -4.37112e-08 2.5 0)",
    stroke: "#867BEA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecordWaveRight);
export default __webpack_public_path__ + "static/media/icon-record-wave-right.47f4d2fac9f41c8f58385111b1373562.svg";
export { ForwardRef as ReactComponent };